module.exports = __webpack_public_path__ + "img/avatar.476a3994.png";